module.exports = __webpack_public_path__ + "media/images/aside-0e0c2117ed6cbd428c8efc5403833aa6.png";